export const boundCheck = (field, val) => {
    return (field.minNum != null ? (val < field.minNum) : false) || (field.maxNum != null ? (val > field.maxNum) : false)
}

export const isNumField = (t) => {
    return ['INTEGER', 'CURRENCY', 'DOUBLE'].includes(t)
}

export const boundError = (f, val) => {
   return (isNumField(f.type) ? boundCheck(f, val) : false)
}